import React from "react";
import styled from "styled-components";
import { useAuth } from "react-oidc-context";
import { useClientContext } from "../../../hooks/ClientContext";
import { ThemedSpan } from "../../../components/utilities";
import { IconButton } from "../../../components";
import { openMailPopout } from "../../../components/modals/email-popout";
import { toNString } from "../../../helpers/guids";

const ConversationListHeader = styled.div`
    background-color: ${props => props.theme.primary};
    color: white;
`;

const ClientEmailConversationPreviewListHeader = () => {
    const { id } = useClientContext();
    const { user: { profile } } = useAuth();

    const onNewEmailCreate = () => {
        openMailPopout('new', {
            masterAccountId: id,
            projectId: null,
            subject: '',
            body: '',
            attachments: [],
            from: toNString(profile.sub),
            toRecipients: [],
            ccRecipients: [],
            bccRecipients: []
        })
    };

    return <React.Fragment>
        <ConversationListHeader className="row h-100 border d-flex m-0">
            <div className="col d-flex align-items-center">
                <ThemedSpan variant="light" className="h-4 ps-0">Conversations</ThemedSpan>
            </div>
            <div className="col-auto d-flex align-items-center">
                <IconButton
                    icon="fa-plus"
                    variant="success"
                    onClick={onNewEmailCreate}
                />
            </div>
        </ConversationListHeader>
    </React.Fragment>;
};

export default ClientEmailConversationPreviewListHeader;